import React, { useEffect, useState } from "react";
import styles from "../commanstyles.module.css";
import { getIndexopenCharges } from "../../../Services/APIrequests";
import { useParams } from "react-router-dom";
import { FaRupeeSign } from "react-icons/fa";
import {
    HiArrowsUpDown,
    HiOutlineArrowUp,
    HiOutlineArrowDown,
} from "react-icons/hi2";

const IndexCharges = ({ refreshLoading }) => {
    const [openChargeData, setOpenChargeData] = useState([]);
    const { cin } = useParams();
    const [currency, setCurrency] = useState("INR");

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCounts, setTotalCounts] = useState(0);
    const limit = 10;

    const formatNumber = (num) => {
        return num.toLocaleString();
    };

    // const convertValue = (value) => {
    //     switch (currency) {
    //         case "Lakh":
    //             return value / 100000;
    //         case "Million":
    //             return value / 1000000;
    //         case "INR":
    //             return value;
    //         case "Crore":
    //             return value / 10000000
    //         default:
    //             return value;
    //     }
    // };


    const convertValue = (value) => {
        const num = Number(value) || 0;
        switch (currency) {
            case "Lakh":
                return num / 100000;
            case "Million":
                return num / 1000000;
            case "Crore":
                return num / 10000000;
            case "INR":
            default:
                return num;
        }
    };

    const getIndicator = (field) => {
        if (sortField !== field) {
            return (
                <HiArrowsUpDown
                    style={{
                        marginLeft: "6px",
                        fontSize: "16px",
                        color: "#fff",
                        fontWeight: "600",
                    }}
                />
            );
        }
        return sortOrder === "asc" ? (
            <HiOutlineArrowUp
                style={{
                    marginLeft: "6px",
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "600",
                }}
            />
        ) : (
            <HiOutlineArrowDown
                style={{
                    marginLeft: "6px",
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "600",
                }}
            />
        );
    };

    const sortData = (field) => {
        const sortedData = [...openChargeData];
        const newSortOrder =
            sortField === field && sortOrder === "asc" ? "desc" : "asc";

        setSortField(field);
        setSortOrder(newSortOrder);

        sortedData.sort((a, b) => {
            if (field === "creationDate") {
                const dateA = new Date(a.filing_date).getTime();
                const dateB = new Date(b.filing_date).getTime();
                return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
            }

            if (field === "modificationDate") {
                const dateA = new Date(a.dateOfModification).getTime();
                const dateB = new Date(b.dateOfModification).getTime();
                return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
            }

            if (field === "holder") {
                const nameA = (a.charge_order_name || "").toLowerCase();
                const nameB = (b.charge_order_name || "").toLowerCase();
                return newSortOrder === "asc"
                    ? nameA.localeCompare(nameB)
                    : nameB.localeCompare(nameA);
            }

            if (field === "amount") {
                const amountA = convertValue(a.amount || 0);
                const amountB = convertValue(b.amount || 0);
                return newSortOrder === "asc"
                    ? amountA - amountB
                    : amountB - amountA;
            }

            return 0;
        });

        setOpenChargeData(sortedData);
    };

    useEffect(() => {
        async function fetchChargeData() {
            try {
                const response = await getIndexopenCharges(cin, currentPage, limit);
                if (response.data && response.data.openCharges) {
                    setOpenChargeData(response.data.openCharges);
                    if (response.data.pagination) {
                        setCurrentPage(response.data.pagination.currentPage);
                        setTotalPages(response.data.pagination.totalPages);
                        setTotalCounts(response.data.pagination.totalCounts);
                    }
                } else if (
                    response.data?.message ===
                    "No open charges found for the given CIN"
                ) {
                    setOpenChargeData([]);
                    setTotalPages(1);
                    setTotalCounts(0);
                } else {
                    console.log("No charge details found in response");
                }
            } catch (error) {
                console.error("Failed to fetch charge data:", error);
                console.error(
                    error.response?.data?.message || "Something went wrong"
                );
            }
        }
        if (refreshLoading == false) {
            fetchChargeData();
        }
        // fetchChargeData();
    }, [cin, currentPage], refreshLoading);

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [currentPage]);

    return (
        <div className={styles.Indexcharge_container}>
            <div className={styles.headertext_con}>
                <h1 id={styles.headertext}>Active Charges</h1>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                    }}>
                    {/* Icon */}
                    <div
                        style={{
                            fontSize: "18px",
                            color: "var(--PrimaryColor)",
                        }}>
                        <FaRupeeSign />
                    </div>

                    {/* Dropdown */}
                    <div>
                        <select
                            value={currency}
                            onChange={(e) => setCurrency(e.target.value)}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                                outline: "none",
                                cursor: "pointer",
                                minWidth: "120px",
                            }}>
                            <option value="Crore">Crore</option>
                            <option value="Lakh">Lakh</option>
                            <option value="INR">INR</option>
                            <option value="" disabled>
                                --------
                            </option>
                            <option value="Million">Million</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className={styles.table_subcontainer}>
                <table className={styles.commantable}>
                    <thead className={styles.table_header}>
                        <tr className={styles.tableHeaderRow}>
                            <th className={styles.tableHeader}>Sr. No</th>
                            <th className={styles.tableHeader}>Charge Id</th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("holder")}
                                style={{ cursor: "pointer" }}>
                                Charge Holder Name{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("holder")}
                                </span>
                            </th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("creationDate")}
                                style={{ cursor: "pointer" }}>
                                Date of Creation{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("creationDate")}
                                </span>
                            </th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("modificationDate")}
                                style={{ cursor: "pointer" }}>
                                Date of Modification{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("modificationDate")}
                                </span>
                            </th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("amount")}
                                style={{ cursor: "pointer" }}>
                                Amount{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("amount")}
                                </span>
                            </th>

                            <th className={styles.tableHeader}>
                                Charge Holder Address
                            </th>
                            <th className={styles.tableHeader}>
                                Whether charge registered by other entity
                            </th>
                            <th className={styles.tableHeader}>
                                Asset Holder Name
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {openChargeData.length > 0 ? (
                            openChargeData.map((charge, index) => (
                                <tr key={charge.id} className={styles.tableRow}>
                                    <td className={styles.tableCell}>
                                        {(currentPage - 1) * limit + index + 1}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.charge_id}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.charge_order_name || "-"}
                                    </td>

                                    <td className={styles.tableCell}>
                                        {charge.date &&
                                            charge.status != "Modification" &&
                                            !isNaN(new Date(charge.date).getTime())
                                            ? new Date(
                                                charge.date
                                            ).toLocaleDateString("en-GB", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                            })
                                            : "-"}
                                    </td>

                                    <td className={styles.tableCell}>
                                        {charge.dateOfModification &&
                                            charge.status == "Modification" &&
                                            !isNaN(new Date(charge.dateOfModification).getTime())
                                            ? new Date(
                                                charge.dateOfModification
                                            ).toLocaleDateString("en-GB", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                            })
                                            : "-"}
                                    </td>

                                    <td className={styles.tableCell}>
                                        {formatNumber(
                                            convertValue(charge.amount)
                                        )}
                                        {/* {charge.amount} */}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.chargeHolderAddress || "-"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge?.whetherCharge == 1
                                            ? "Yes"
                                            : "No"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.assetHolderName || "-"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td style={{textAlign:"center"}} colSpan="9" className={styles.noDataRow}>
                                    No open charges found for the given CIN
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {openChargeData.length > 0 && totalPages > 1 && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                    marginTop: '20px',
                    padding: '10px'
                }}>
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            backgroundColor: currentPage === 1 ? '#f0f0f0' : 'var(--PrimaryColor)',
                            color: currentPage === 1 ? '#999' : '#fff',
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                        Previous
                    </button>
                    
                    <span style={{
                        fontSize: '14px',
                        color: '#333',
                        fontWeight: '500'
                    }}>
                        Page {currentPage} of {totalPages} ({totalCounts} total)
                    </span>
                    
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            backgroundColor: currentPage === totalPages ? '#f0f0f0' : 'var(--PrimaryColor)',
                            color: currentPage === totalPages ? '#999' : '#fff',
                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default IndexCharges;
